import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "card"]

  connect() {
    this.index = 0
    this.textTargets.forEach((el, i) => {
      el.classList.toggle("hidden", i !== 0)
    })
    this.cards = this.cardTargets
    this.startRotation()
  }

  startRotation() {
    setInterval(() => {
      this.textTargets.forEach(el => el.classList.add("hidden"))

      this.index = (this.index + 1) % this.textTargets.length
      const currentText = this.textTargets[this.index]
      currentText.classList.remove("hidden")

      const currentTitle = currentText.textContent.toLowerCase()
      this.cards.forEach(card => {
        if (currentTitle === "nos services") {
          card.classList.remove("blur-sm")
        } else {
          card.classList.toggle("blur-sm", card.dataset.cardTitle.toLowerCase() !== currentTitle)
        }
      })

    }, 2000)
  }
}
